import {
  Button,
  Checkbox,
  Divider,
  Drawer,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { memo } from "react";
import LoadingCheckBox from "../../resultadoexercicio/children/LoadingCheckBox";
import { drawersKey } from "../RankingClienteConstants";
import { useRankingClienteService } from "../context/RankingClienteContext";
import CheckSituation from "./Drawer/CheckSituation";

const SituationsDrawer = () => {
  const {
    openedDrawer,
    setDrawerOpen,
    cachedSituations,
    isSituationsLoading,
    quickSituations,
    handleCheckQuickSituations,
    handleCheckSituations,
    handleCheckAll,
    isIndeterminate,
    clearAllSituationsFilters,
    setSituations,
  } = useRankingClienteService();

  const handleClose = () => {
    setDrawerOpen(null);
    setSituations();
  };

  return (
    <Drawer
      open={openedDrawer === drawersKey.situation}
      anchor="right"
      onClose={() => {
        handleClose();
      }}
    >
      <Grid
        container
        direction="column"
        style={{
          width: 480,
          height: "100%",
          maxHeight: "100vh",
          flexWrap: "nowrap",
        }}
      >
        <Grid
          item
          aria-label="drawer-header"
          style={{
            padding: 16,
            borderBottom: "1px solid #dddddd",
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
        >
          <IconButton
            onClick={() => {
              handleClose();
            }}
            size="small"
          >
            <Close />
          </IconButton>
          <Typography variant="h6"> Situações</Typography>
        </Grid>
        <Grid
          container
          item
          xs
          spacing={2}
          direction="column"
          style={{
            padding: "16px 32px 32px  32px  ",
          }}
        >
          <Grid item>
            <Typography variant="subtitle1">Situações rápidas</Typography>
          </Grid>
          <Grid item container spacing={1} direction="row">
            {quickSituations.map((situation) => (
              <Grid item key={situation.id} xs>
                <CheckSituation
                  fullWidth
                  label={situation.desc}
                  checked={situation.checked}
                  handleCheck={() =>
                    handleCheckQuickSituations(situation, !situation.checked)
                  }
                />
              </Grid>
            ))}
          </Grid>
          <Grid item>
            <Divider />
          </Grid>
          <Grid item>
            <Typography variant="subtitle1">Todas as situações</Typography>
          </Grid>
          <Grid item>
            <CheckSituation
              label={`${
                cachedSituations.every((situation) => situation.checked)
                  ? "Desmarcar"
                  : "Marcar"
              } todos`}
              fullWidth
              disabled={!cachedSituations.length}
              indeterminate={isIndeterminate}
              checked={cachedSituations.every((situation) => situation.checked)}
              handleCheck={() =>
                handleCheckAll(
                  cachedSituations.some((situation) => !situation.checked)
                )
              }
            />
          </Grid>
          <Grid
            item
            xs
            style={{
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {isSituationsLoading
              ? Array(8)
                  .fill(<LoadingCheckBox />)
                  .map((loadingSkeleton) => loadingSkeleton)
              : cachedSituations.map((situation) => (
                  <Grid item xs={12} key={situation.id}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={situation.checked}
                          onChange={(event) =>
                            handleCheckSituations(
                              situation,
                              event.target.checked
                            )
                          }
                          name={situation.desc}
                        />
                      }
                      label={situation.desc}
                    />
                  </Grid>
                ))}
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            padding: "16px",
            borderTop: "1px solid #dddddd",
            gap: "16px",
          }}
          container
        >
          <Grid item xs>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={async () => {
                handleClose();
              }}
            >
              Aplicar
            </Button>
          </Grid>
          <Grid item xs>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => {
                clearAllSituationsFilters();
              }}
            >
              Limpar tudo
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default memo(SituationsDrawer);
